var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 45,
    viewBox: "0 0 104 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_2642_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.939 3.98117V5.61545H88.0262C88.9595 5.61545 90.3696 5.61545 91.3074 6.56184C92.2452 7.49475 92.2452 8.90199 92.2452 9.84389V23.9072C92.2452 24.8401 92.2452 26.2541 91.3074 27.187C90.3696 28.1267 88.9595 28.1267 88.0262 28.1267H81.221C80.0493 28.1267 78.5223 28.1267 77.9353 26.8341C77.3506 25.5483 78.167 24.3748 78.8754 23.4374L88.024 11.2556H73.9367L68.3167 18.7549C67.3789 20.0115 66.5625 21.095 66.5625 22.5C66.5625 23.9072 67.3136 24.9233 68.3167 26.2541L69.7312 28.1267C71.1278 29.9992 72.5401 31.8786 74.4135 32.8182C76.2936 33.7511 78.52 33.7511 81.5718 33.7511H87.6732C91.1882 33.7511 96.4709 33.7511 99.9838 30.2398C103.501 26.7217 103.501 21.5648 103.501 19.6855V14.0566C103.501 12.1818 103.501 7.02493 99.9838 3.51359C96.4732 0 91.1882 0 87.6754 0H77.9376C77.0043 0 75.8258 0 74.8925 0.93291C73.939 1.87032 73.939 3.03926 73.939 3.98117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8671 11.2539H69.9363L53.0514 33.7539H38.9844L55.8671 11.2539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2261C0 14.2932 0 13.1175 0.935552 12.1801C1.87335 11.2539 3.04504 11.2539 3.98734 11.2539H27.5516C30.6011 11.2539 32.8343 11.2539 34.7032 12.1801C36.5833 13.1197 37.9911 14.999 39.4057 16.8716L40.8045 18.7532C41.8008 20.0795 42.5654 21.0933 42.5654 22.4983C42.5654 23.9055 41.749 24.9935 40.8045 26.2524L35.1754 33.7539H21.1017L30.2503 21.5609C30.9564 20.628 31.7751 19.4568 31.1926 18.1597C30.5989 16.8694 29.0763 16.8694 27.9002 16.8694H16.8849V45.0005H5.62906V16.8694H0V15.2261Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2642_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.5,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb14);
export default __webpack_public_path__ + "static/media/ab (14).dbbac90a062b9ab40900d940f3312c7a.svg";
export { ForwardRef as ReactComponent };